export default __webpack_public_path__ + "static/media/intro-button-add.eb9674f7.png";